import useScrollAnimation from '@/hooks/useScrollAnimation';

const publishingDirections = [
  {
    id: 'aigc',
    title: 'AIGC 彩色書籍',
    description: '透過彩色圖像與知識內容，提供更具視覺性與閱讀性的出版作品。',
    icon: 'ri-palette-line',
  },
  {
    id: 'smithsonian',
    title: '史密森學會科普內容',
    description: '出版與自然、科學及世界知識相關的科普閱讀內容，實際內容來源與出版資訊以個別書籍資料為準。',
    icon: 'ri-earth-line',
  },
];

export default function PublishingSection() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.08 });

  return (
    <section
      ref={ref}
      className="relative min-h-[100svh] flex flex-col items-center justify-center bg-background-50 overflow-hidden py-20 md:py-0"
    >
      <div className="relative z-10 flex flex-col items-center text-center px-6 md:px-10 w-full">
        <div
          className={`max-w-[720px] w-full transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-block text-xs text-foreground-400 uppercase tracking-widest mb-4">
            出版方向
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-5">
            主要出版方向
          </h2>
          <p className="text-foreground-500 text-sm md:text-base leading-relaxed max-w-[600px] mx-auto mb-14 text-balance">
            沐燁文化聚焦 AIGC 彩色書籍與史密森學會科普內容，透過圖像與知識的結合，提供具視覺閱讀特色的科普出版內容。
          </p>
        </div>

        <div
          className={`grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-[800px] w-full transition-all duration-700 ease-out delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {publishingDirections.map((dir) => (
            <div
              key={dir.id}
              className="flex flex-col items-center text-center p-8 md:p-10 bg-background-100 border border-background-200/70 rounded-xl group hover:border-primary-200/80 transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-5 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${dir.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">
                {dir.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-[300px]">
                {dir.description}
              </p>
            </div>
          ))}
        </div>

        <div
          className={`mt-10 transition-all duration-700 ease-out delay-200 flex flex-col items-center gap-3 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <p className="text-xs text-foreground-400 leading-relaxed text-center max-w-[520px] text-balance">
            完整書名、作者、內容來源及相關出版資訊，以崧博書籍資料庫中的個別書籍頁為準。
          </p>
          <a
            href="https://catalog.sonbook.net/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-database-2-line"></i>
            </span>
            前往書籍資料庫
          </a>
        </div>
      </div>
    </section>
  );
}